import React from "react"

import { Results, ResultsTitle, Calcs, Text, Result, } from "../styles/ResultsContainer.styled"
import DetailBreakdown from "./DetailBreakdown"

const ResultsContainer = ({ 
  annualApprovalsSavings, 
  annualProductivitySavings, 
  annualItSavings, 
  total, 
  isDetail, 
  formSubmitted, 
  prodHoursSaved, 
  ticketsPerEmp,
  employees
}) => (
  <>
    {isDetail && formSubmitted &&
      <DetailBreakdown 
        annualApprovalsSavings={annualApprovalsSavings} 
        annualProductivitySavings={annualProductivitySavings}
        annualItSavings={annualItSavings}
        prodHoursSaved={prodHoursSaved}
        ticketsPerEmp={ticketsPerEmp}
      />
    }
    <Results isDetail={isDetail}>
      <ResultsTitle isDetail={isDetail}>ROI Calculation Results</ResultsTitle>
      <Calcs>
        {isDetail &&
          <>
            <Text>
              <p>Number of employees in your organization</p>
            </Text>
            <Result>
              {employees}
            </Result>
          </>
        }
        <Text>
          <p>Streamlining Approvals</p>
          <p>Employee Productivity Savings</p>
        </Text>
        <Result>
          {annualApprovalsSavings}
        </Result>
        <Text>
          <p>Minimize Time to Find Information</p>
          <p>Employee Productivity Savings</p>
        </Text>
        <Result>
          {annualProductivitySavings}
        </Result>
        <Text>
          <p>IT/HR Support Cost Savings</p>
        </Text>
        <Result>
          {annualItSavings}
        </Result>
      </Calcs>
      <Calcs>
        <Text total>Total Savings</Text>
        <Result total>{total}</Result>
      </Calcs>
    </Results>
  </>
)

export default ResultsContainer